// extracted by mini-css-extract-plugin
module.exports = {"container":"Section6_container__3ZCfq","about":"Section6_about__1sujr","title":"Section6_title__37MCy"};